const data = {
	title: "Data Management",
	export_title: "Export",
	import_title: "Import",
	exportimport_title: "Export/Import",
	select_module: "Select module",
	view_data: "View data",
	download_import_template: "Download template",
	select_import_template: "Select import template",
	import_file: "Import file",
	import_success: "File successfully imported",
	invalid_file: "Invalid excel file template",
	import_failed: "File failed to import",
	student_to_groups: "Students to Student Group",
};
export default data;